<template>
  <div :id="componentId" class="spm1-title" :style="{ backgroundColor }">
    <div class="spm1-title-box" :style="boxStyle">
      <span class="spm1-title-text" :style="{ color: titleColor }">{{ titleContent }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileSpecialOneTitle',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_title'
    }
  },
  data() {
    return {
      backgroundColor: '#fffff0',
      titleBackgroundImage: require('../../../special/SpecialOne/assets/img/title_bg_green.png'),
      titleContent: '大会议程',
      titleColor: '#000000',
      titlePosition: 2
    }
  },
  computed: {
    boxStyle() {
      const positionMap = {
        1: { marginLeft: '0', marginRight: 'auto' },
        2: { margin: '0 auto' },
        3: { marginLeft: 'auto', marginRight: '0' }
      }
      return {
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        ...positionMap[this.titlePosition] || positionMap[2]
      }
    }
  }
}
</script>

<style scoped>
.spm1-title {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm1-title-box {
  width: 180px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spm1-title-text {
  font-size: 20px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  line-height: 1;
}
</style>
